import regularTaskTypesApi from '@/api/regularTaskTypes';

const state = {
  regularTaskTypes: [],
};

export const getters = {
  formattedRegularTaskTypes: state =>
    state.regularTaskTypes.map(type => ({
      label: type.name,
      value: type.typeGuid,
    })),

  formattedType: state => (typeGuid) => {
    let name = '';
    for (let i = 0; i < state.regularTaskTypes.length; i += 1) {
      if (typeGuid === state.regularTaskTypes[i].typeGuid) {
        // eslint-disable-next-line
        name = state.regularTaskTypes[i].name;
      }
    }
    return name;
  },
};

export const actions = {
  getList({ commit }) {
    regularTaskTypesApi.getRegularTaskTypes().then((data) => {
      commit('regularTaskTypes', data.regularTaskTypes);
    });
  },
};
export const mutations = {
  regularTaskTypes(state, payload) {
    state.regularTaskTypes = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
